/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
// import {
//   Switch, Route, Redirect,
// } from 'react-router-dom';
import { useRoutes, RouteObject, Navigate } from 'react-router';
import './css/toggle.css';
import './css/custom.css';
import './css/responsive.css';

import AddCloud from './screens/addCloud';
import AllNetwork from './screens/allNetwork';
import Dashboard from './screens/dashboard';
import MyAccount from './screens/myAccount';
import Workspace from './screens/workspace';
import { prefixPath } from './utils/helpers';
import Invitation from './screens/invitation';
import PaymentCheckout from './screens/paymentCheckout';
import Success from './screens/success';
import Urls from './utils/urls';
import MainLayout from './layouts/mainLayout';
import EmptyLayout from './layouts/emptyLayout';
import DedicatedNodeConfig from './screens/dedicatedNodeConfig';
import SharedNodeConfig from './screens/sharedNodeconfig';
import AllEndpoint from './screens/allEndpoint';
import WorkspaceResource from './screens/workspaceResources';
import Marketplace from './screens/marketplace';
import PurchaseEndpoint from './screens/purchaseEndpoint';
import PIPBody from './components/PurchaseIndexingProtocol/PIPBody';
import CreateEndpoint from './screens/createEndpoint';
import StakingNetwork from './screens/allStakingNetwork';
import StakingMarketplace from './screens/stakingMarketplace';
import ProtocolContactUs from './screens/protocolContactUs';
import ProtocolPurchase from './screens/protocolPurchase';
import Alerts from './screens/alerts';
import NetworkDetailsPage from './components/viewNetwork/viewNetworkNode';
import ChannelMainBody from './components/myAccount/communicationChannel/addCommunicationChannel/channelBody';

const paths = [
  prefixPath('/dashboard'),
  prefixPath('/addcloud/:cloud/:id'),
  prefixPath('/Workspace'),
  prefixPath('/workspace/:id'),
  prefixPath('/Account'),
  prefixPath('/allNetwork'),
  prefixPath('/marketplace'),
  prefixPath('/dashboard'),
  prefixPath('/invitation'),
  prefixPath('/checkout/:id'),
  prefixPath('/endpoint/subscriptions'),
  prefixPath('/success'),
  prefixPath('/network/subscriptions'),
  prefixPath('/endpoints'),
  prefixPath('/endpoint/buy'),
  prefixPath('/endpoint/create'),
  prefixPath('/marketplace/staking-nodes'),
  prefixPath('/network/staking-nodes'),
  prefixPath('/protocol/contactus'),
  prefixPath('/protocol/purchase/dedicated-nodes'),
  prefixPath('/protocol/purchase/staking-nodes'),
  prefixPath('/alerts'),
  prefixPath('/alerts'),
  prefixPath('/indexing-protocol/buy'),
  prefixPath('/network-info/:id'),
  prefixPath('/addCommunicationChannel/:channel'),
];
const routes: RouteObject[] = [
  {
    children: [
      {
        path: prefixPath('/'),
        element: <Navigate to={paths[0]} replace />,
      },
      {
        element: <MainLayout />,
        children: [
          {
            path: paths[0],
            element: <Dashboard />,
          },
          {
            path: prefixPath('*'),
            element: <Navigate to={paths[0]} replace />,
          },
          {
            path: paths[2],
            element: <Workspace />,
          },
          {
            path: paths[3],
            element: <WorkspaceResource />,
          },
          {
            path: paths[4],
            element: <MyAccount />,
          },
          {
            path: paths[5],
            element: <AllNetwork />,
          },
          {
            path: paths[6],
            element: <Marketplace />,
          },
          {
            path: paths[8],
            element: <Invitation />,
          },
          {
            path: paths[9],
            element: <PaymentCheckout />,
          },
          {
            path: paths[10],
            element: <SharedNodeConfig />,
          },
          {
            path: paths[11],
            element: <Success />,
          },
          {
            path: paths[12],
            element: <DedicatedNodeConfig />,
          },
          {
            path: paths[13],
            element: <AllEndpoint />,
          },
          {
            path: paths[14],
            element: <PurchaseEndpoint />,
          },
          {
            path: paths[15],
            element: <CreateEndpoint />,
          },
          {
            path: paths[16],
            element: <StakingMarketplace />,
          },
          {
            path: paths[17],
            element: <StakingNetwork />,
          },
          {
            path: paths[18],
            element: <ProtocolContactUs />,
          },
          {
            path: paths[19],
            element: <ProtocolPurchase />,
          },
          {
            path: paths[20],
            element: <ProtocolPurchase />,
          },
          {
            path: paths[21],
            element: <Alerts />,
          },
          {
            path: paths[23],
            element: <PIPBody />,
          },
          {
            path: paths[24],
            element: <NetworkDetailsPage />,
          },
        ],
      },
      {
        element: <EmptyLayout />,
        children: [
          {
            path: paths[1],
            element: <AddCloud />,
          },
          {
            path: paths[25],
            element: <ChannelMainBody />,
          },
        ],

      },
    ],
  },
];

function App() {
  useEffect(() => {
    ReactGA.initialize('GTM-KMMVTKT');
    if (Urls.getEnvironment() === 'production') {
      ReactGA.send(window.location.pathname + window.location.search);
    }
  }, []);
  const element = useRoutes(routes);

  return element;
}

export default App;
